import { useQueryClient } from "@tanstack/react-query";

import type { Flow } from "src/api/flowTypes";
import { flowKeys } from "src/api/queries";
import {
  useCopilotContextualEntities,
  useCopilotRefetchOnMutation,
} from "src/unifiedCopilot/context/hooks";
import type { ReferenceContextualEntity } from "src/unifiedCopilot/context/types";

const LISTED_FLOW_ARCHIVED_VARIANTS: ReadonlyArray<boolean | undefined> = [
  undefined,
  true,
];

export const useFlowVersionsCopilotContext = (flow: Flow | undefined): void => {
  const queryClient = useQueryClient();

  useCopilotContextualEntities(
    flow
      ? [
          {
            kind: "reference",
            type: "flow",
            id: flow.id,
            displayName: flow.name,
          },
        ]
      : [],
    { includeInAgentContext: true },
  );

  const versionEntities: ReferenceContextualEntity[] = flow
    ? flow.versions.map((version) => ({
        kind: "reference",
        type: "flow-version",
        id: version.id,
        displayName: version.name,
        parent: { type: "flow", id: flow.id },
      }))
    : [];
  useCopilotContextualEntities(versionEntities);

  const flowId = flow?.id;
  useCopilotRefetchOnMutation(async () => {
    if (!flowId) return;

    await Promise.all(
      LISTED_FLOW_ARCHIVED_VARIANTS.map((includeArchivedFlowVersions) =>
        queryClient.invalidateQueries({
          queryKey: flowKeys.detail(flowId, includeArchivedFlowVersions),
          exact: true,
        }),
      ),
    );
  });
};
